class Elementor_Product_Review{
    static instance;

    static getInstance() {
        if (!Elementor_Product_Review.instance) {
            Elementor_Product_Review.instance = new Elementor_Product_Review();
        }
        return Elementor_Product_Review.instance;
    }

    constructor(){
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init(){
        elementorFrontend.hooks.addAction( 'frontend/element_ready/opal-product-review.default', ( $scope ) => {
            $scope.find('.woocommerce-review-link').magnificPopup({
                type: 'inline',
                removalDelay: 500,
                callbacks: {
                    beforeOpen: function() {
                        this.st.mainClass = this.st.el.attr('data-effect');
                    }
                },
                midClick: true
            });
            $scope.on('click','.show-all-reviews', (e) => {
                e.preventDefault();
                $scope.find('.commentlist > li:nth-child(n + 4)').show(500);
                $scope.find('.show-all-reviews').delay(500).hide(200);

            })
        } );
    }
}
Elementor_Product_Review.getInstance();
